import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { isNetworkIdle } from "../Utils/networkTracker";

// Keeps the newsletter and footer hidden until the page content has arrived,
// so they never flash at the top of an empty page.
const MIN_HIDDEN_MS = 300;
const MAX_HIDDEN_MS = 4000;

const FooterGate = ({ children }) => {
  const location = useLocation();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(false);
    const start = Date.now();
    const poll = setInterval(() => {
      const waited = Date.now() - start;
      if ((waited >= MIN_HIDDEN_MS && isNetworkIdle()) || waited >= MAX_HIDDEN_MS) {
        clearInterval(poll);
        setReady(true);
      }
    }, 100);
    return () => clearInterval(poll);
  }, [location.pathname]);

  return <div className={ready ? "footer-gate" : "footer-gate footer-gate-hidden"}>{children}</div>;
};

export default FooterGate;
